import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33ddc4c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-index" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_Comment = _resolveComponent("Comment")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, {
      skipPath: $setup.back_fn,
      title: "Customer Reviews"
    }, null, 8, ["skipPath"]),
    _createVNode(_component_van_tabs, {
      active: $setup.active,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => (($setup.active) = $event)),
      "swipe-threshold": "4",
      onClick: $setup.onTabs
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tabList, (item) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            title: item.title,
            key: item.id,
            name: item.id
          }, null, 8, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active", "onClick"]),
    _createVNode(_component_van_list, {
      loading: $setup.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      "finished-text": "No more",
      onLoad: $setup.onLoad,
      "loading-text": "loading"
    }, {
      default: _withCtx(() => [
        _createElementVNode("ul", {
          class: _normalizeClass(["exhibition", { unfold_active: $setup.active === true }])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.commentList, (item) => {
            return (_openBlock(), _createElementBlock("li", {
              key: item.goodsId
            }, [
              _createVNode(_component_Comment, {
                item: item,
                comment: true
              }, null, 8, ["item"])
            ]))
          }), 128))
        ], 2)
      ]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"])
  ]))
}